// 일정 상세 하단 "당일 순위" 섹션 — leaderboard + (해당되면) 팀 MVP 카드.
//
// 데이터 계산은 events/ranking.ts의 computeEventRanking이 담당하고
// 이 컴포넌트는 받은 rows/mvp만 그린다.

import type { EventRanking as EventRankingData, RankingRow } from "../../events/ranking";

interface EventRankingProps {
  data: EventRankingData;
}

function formatDiff(diff: number): string {
  return `${diff >= 0 ? "+" : ""}${diff}`;
}

function LeaderRow({ row, index }: { row: RankingRow; index: number }) {
  const rateStr = row.decided > 0 ? `${Math.round((row.wins / row.decided) * 100)}%` : "-";
  const rankClass =
    "leader-row__rank" + (index < 3 ? ` leader-row__rank--top${index + 1}` : "");
  return (
    <div class="leader-row">
      <span class={rankClass}>{index + 1}</span>
      <div class="leader-row__main">
        <span class="leader-row__name">{row.label}</span>
        <span class="leader-row__sub">{`${row.total}경기`}</span>
        <span class="leader-row__sub">
          {`득 ${row.scored} · 실 ${row.conceded} · 득실 ${formatDiff(row.diff)}`}
        </span>
      </div>
      <div class="leader-row__record">
        <span class="leader-row__wl">
          <span class="leader-row__wins">{`${row.wins}승`}</span>
          {row.draws > 0 ? (
            <>
              {" "}
              <span class="leader-row__draws">{`${row.draws}무`}</span>
            </>
          ) : null}{" "}
          <span class="leader-row__losses">{`${row.losses}패`}</span>
        </span>
        <span class="leader-row__rate">{rateStr}</span>
      </div>
    </div>
  );
}

export function EventRanking({ data }: EventRankingProps) {
  const { isTeam, rows, mvp } = data;
  return (
    <div class="section">
      <div class="section__title">
        <h3>당일 순위</h3>
        <span class="count">{isTeam ? "팀별" : "개인별"}</span>
      </div>
      {mvp ? (
        <div class="mvp-card">
          <div class="mvp-card__headline">{`🏆 오늘 MVP: ${mvp.name} 🎉`}</div>
          <div class="mvp-card__sub">
            {`${mvp.teamLabel} · ${mvp.record} · 승률 ${mvp.rate} · 득실 ${formatDiff(mvp.diff)}`}
          </div>
        </div>
      ) : null}
      <div class="leaderboard">
        {rows.map((r, i) => (
          <LeaderRow row={r} index={i} />
        ))}
      </div>
    </div>
  );
}
